import { CustomerCollectionInterface } from 'client/Interfaces/CustomerInterface'
import { StateInterface } from 'client/Interfaces/StateInterface'

import { ExchangeRateInterface } from '../Interfaces/ExchangeRateInterface'
import { Immutable } from '../Other/Immutable'
import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = null

type StateType = ExchangeRateInterface | null
type PayloadType = ExchangeRateInterface

const reducer = ReducerBuilder.create<StateType, PayloadType>(INITIAL_STATE)
  .mapAction('GET_EXCHANGE_RATE', (state: StateType, payload: PayloadType) => payload)
  .build()

export default reducer

// selectors
export const exchangeRateSelector = (state: StateInterface): ExchangeRateInterface => state.exchangeRate
